import {
  ADD_COMMENT_REQUEST_ASYNC,
  ADD_REPLY_REQUEST_ASYNC,
  COMMENTS_REQUEST_ASYNC,
  DELETE_COMMENT_REQUEST_ASYNC,
  EDIT_COMMENT_REQUEST_ASYNC,
  SAVE_NICKNAME_REQUEST_ASYNC,
  SET_REPORT_DATA,
  TOGGLE_COMMUNITY_TAB,
} from './constants'

export default function () {
  const initialState = {
    data: [],
    loader: false,
    error: null,
    reportData: null,
    communityTab: false,
    communityUserError: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case SET_REPORT_DATA:
        return {
          ...state,
          reportData: {
            reportId: action.payload.reportId,
            reportType: action.payload.reportType,
          },
          communityTab: !!action.payload.communityTab,
        }
      case TOGGLE_COMMUNITY_TAB:
        return {
          ...state,
          communityTab: action.payload.val,
          loader: true,
        }
      case SAVE_NICKNAME_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true }
      case COMMENTS_REQUEST_ASYNC.INITIATE:
        if (action.payload?.background) return state
        return { ...state, loader: true }
      case SAVE_NICKNAME_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          error: null,
          loader: false,
          communityUserError: null,
        }
      case SAVE_NICKNAME_REQUEST_ASYNC.ERROR:
        return {
          ...state,
          communityUserError: action.error,
          loader: false,
        }
      case COMMENTS_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          error: null,
          data: action.payload.data,
          loader: false,
          communityUserError: null,
        }
      case COMMENTS_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error }
      case COMMENTS_REQUEST_ASYNC.CANCEL:
        return {
          ...state,
          data: [],
          loader: false,
          reportData: null,
        }
      case EDIT_COMMENT_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true }
      case EDIT_COMMENT_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error }
      case DELETE_COMMENT_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true }
      case DELETE_COMMENT_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error }
      case ADD_COMMENT_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true }
      case ADD_COMMENT_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error }
      case ADD_REPLY_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true }
      case ADD_REPLY_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error }
      default:
        return state
    }
  }
}
